<template>
    <div class="container admin-table-page">
        <!-- Fila del título y flecha hacia atrás -->
        <div class="param-title-wrap plan-cuentas-header">
            <div class="d-flex align-items-center w-100">
                <div class="d-flex align-items-center">
                    <b-button class="page-back-btn mr-2" variant="link" @click="goBack">
                        <font-awesome-icon :icon="['fas', 'arrow-alt-circle-left']" class="back-icon" />
                    </b-button>
                    <h2 class="param-title">{{ labels.title }}</h2>
                </div>
            </div>
        </div>

        <div class="admin-table-block mt-4">
            <!-- Spinner de carga -->
            <div v-if="isLoading" class="text-center py-5">
                <b-spinner></b-spinner>
                <p class="mt-2">{{ labels.loading }}</p>
            </div>

            <!-- Tabla -->
            <div v-else>
                <CorporateDataTable
                    :items="visibleItems"
                    :fields="allFields"
                    :filter-defs="tableFilterDefs"
                    :labels="tableLabels"
                    :default-per-page="10"
                    :page-options="[10, 20, 50, 100]"
                    :narrow="false"
                    :table-min-height="500"
                    :table-max-height="500"
                    :show-search="true"
                    :allow-column-toggle="true"
                    :enable-sorting="true"
                    :toolbar-disabled="false"
                >
                    <template #cell(cuenta)="data">
                        <div class="text-center"><strong>{{ data.item?.cuenta }}</strong></div>
                    </template>

                    <template #cell(niif)="data">
                        <div class="text-left">{{ data.item?.niif }}</div>
                    </template>

                    <template #cell(accionEdit)="data">
                        <b-button
                            style="background-color: #FF924C; width: 30px; height: 30px;"
                            class="md-fab md-primary table-action-btn"
                            @click.stop="editaNiif(data.item.id)"
                        >
                            <i><font-awesome-icon :icon="['fas', 'pencil-alt']" size="xs"/></i>
                        </b-button>
                    </template>
                </CorporateDataTable>
            </div>
        </div>

        <!-- Modal -->
        <EditaNiifNoControlante 
            :EditNiifNoContr="editNiifNoCont" 
            :regNiif="idNiif" 
            @closeModal="cierraModal"
            @reload="cargaDatos"
        />
    </div>
</template>

<script>
import NiifNoControlante from '../../services/NiifNoControlante'; 
import EditaNiifNoControlante from './EditaNiifNoControlante.vue'; 
import CorporateDataTable from "../utils/CorporateDataTable.vue"

export default {
    name: "NiifNoControlante",
    components: {
        EditaNiifNoControlante,
        CorporateDataTable
    },
    data: () => ({
        listNiifNoCont: [],
        editNiifNoCont: false,
        idNiif: "",
        isLoading: false,
        visibleItems: [],
    }),
    computed: {
        labels() {
            if (this.$store.state._language == "es-ES") {
                return {
                    title: "NIIF no controlante",
                    cuenta: "Cuenta",
                    niif: "Niif",
                    editar: "Editar",
                    loading: "Cargando...",
                    // Etiquetas para la tabla genérica
                    searchPlaceholder: "Buscar en la tabla...",
                    rowsPerPage: "Filas por página:",
                    noSort: "Sin orden",
                    sortAsc: "A-Z / Menor a mayor",
                    sortDesc: "Z-A / Mayor a menor",
                    columns: "Columnas",
                    showAllColumns: "Mostrar todas",
                    filters: "Filtros",
                    clearFilters: "Limpiar filtros",
                    noData: "No hay datos",
                    noMatches: "No se encontraron resultados",
                    filterAccount: "Filtrar cuenta...",
                    filterNiif: "Filtrar NIIF...",
                }
            } else {
                return {
                    title: "NIIF no controlling",
                    cuenta: "Account",
                    niif: "Niif",
                    editar: "Edit",
                    loading: "Loading...",
                    // Etiquetas para la tabla genérica
                    searchPlaceholder: "Search in table...",
                    rowsPerPage: "Rows per page:",
                    noSort: "No sorting",
                    sortAsc: "A-Z / Low to high",
                    sortDesc: "Z-A / High to low",
                    columns: "Columns",
                    showAllColumns: "Show all",
                    filters: "Filters",
                    clearFilters: "Clear filters",
                    noData: "No data",
                    noMatches: "No results found",
                    filterAccount: "Filter account...",
                    filterNiif: "Filter NIIF...",
                }
            }
        },
        allFields() {
            return [
                { key: 'cuenta', label: this.labels.cuenta, sortable: true, thClass: 'text-center', tdClass: 'text-center align-middle' },
                { key: 'niif', label: this.labels.niif, sortable: true, thClass: 'text-left', tdClass: 'text-left align-middle' },
                { key: 'accionEdit', label: this.labels.editar, thClass: 'text-center', tdClass: 'text-center align-middle', sortable: false }
            ]
        },
        tableFilterDefs() {
            return [
                { key: 'cuenta', type: 'text', placeholder: this.labels.filterAccount },
                { key: 'niif', type: 'text', placeholder: this.labels.filterNiif }
            ]
        },
        tableLabels() {
            return {
                noRow: this.labels.noData,
                noMatches: this.labels.noMatches,
                searchPlaceholder: this.labels.searchPlaceholder,
                rowsPerPage: this.labels.rowsPerPage,
                noSort: this.labels.noSort,
                sortAsc: this.labels.sortAsc,
                sortDesc: this.labels.sortDesc,
                columns: this.labels.columns,
                showAllColumns: this.labels.showAllColumns,
                filters: this.labels.filters,
                clearFilters: this.labels.clearFilters
            }
        }
    },
    methods: {
        goBack() {
            this.$router.back()
        },
        
        editaNiif(id) {
            this.editNiifNoCont = true
            this.idNiif = id
        },
        
        cierraModal(val) {
            this.editNiifNoCont = val
        },
        
        cargaDatos() {
            this.isLoading = true
            NiifNoControlante.getAllNiifNoControlante() 
                .then((res) => { 
                    this.listNiifNoCont = res.data.niifNoControlante || []
                    this.visibleItems = [...this.listNiifNoCont]
                })
                .catch((err) => {
                    console.log(err)
                    this.$toast.error('Error al cargar los datos')
                })
                .finally(() => {
                    this.isLoading = false
                })
        }
    },
    mounted() {
        this.cargaDatos()
    }
}
</script>

<style src="../main.css"></style>

<style scoped>
/* Estilos para la flecha y título */
.page-back-btn {
    padding: 0;
    font-size: 1.5rem;
    line-height: 1;
}

.back-icon {
    font-size: 1.75rem !important;
    width: 1.75rem !important;
    height: 1.75rem !important;
}

.param-title {
    font-size: 2rem !important;
    font-weight: 500;
}

.table-action-btn {
    border: none !important;
    border-radius: 50% !important;
    padding: 0 !important;
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
    min-width: 30px !important;
}

.table-action-btn i {
    display: flex;
    align-items: center;
    justify-content: center;
}

/* Ajustes responsivos */
@media (max-width: 576px) {
    .param-title {
        font-size: 1.5rem !important;
    }
}
</style>